import React, { useContext, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router";
import ReceiptDetail from "./ReceiptDetail";
import { getLogDetails, getReceiptDetail, getRoleId } from "./utils";
import moment from "moment";
import ReceiptAction from "./ReceiptActions";
import LogsDetailListing from "./LogsDetails";
import { usePaymentCollectionReceiptContext } from "../context";
import { ReactComponent as BackIcon } from "assets/img/svg/BackArrow.svg";
import {
  getBuIdByDisplayValue,
  headerValidation,
  receiptActionValidation,
} from "./constant";
import ALoader from "views/pages/manage/common/a-loader";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";

const ViewReceipt = ({}) => {
  const [receiptDetail, setReceiptDeatail] = useState({});
  const [totalPaidAmount, setTotalPaidAmount] = useState();
  const [logDetails, setLogDetails] = useState([]);
  const location = useLocation();
  const params = useParams();
  const [header, setHeader] = useState("");
  const [receiptLoader, setReceiptLoader] = useState(false);
  const [actionDisable, setActionDisable] = useState({
    noActionEnable: false,
    modifyPayment: false,
  });
  const queryParams = new URLSearchParams(location.search);

  const {
    setCurrentPaymentMode,
    setStudentBasicDetails,
    modifyPaymentModeData,
    setModifyPaymentModeData,
    setBankDropdown,
    setPaymentModeForm,
    roleId,
    setRoleId,
    setBankMasterId,
    balanceMode,
    setPaymentModeIdLimitList,
    bankDropdown,
    paymentModeIdLimitList,
    paymentModeFormHandler,
    collectVoucherList,
    studentBasicDetails,
    currentPaymentMode,
    paymentModeForm,
    selectedChargesAmount,
    bankMasterId,
    setBalanceMode,
    setBalanceAmount,
    loader,
    setloader,
    setCollectPayment,
    balanceAmount,
    collectPayment,
    availablePosList,
    state,
    setState,
  } = usePaymentCollectionReceiptContext();
  const contextValue = {
    setStudentBasicDetails,
    modifyPaymentModeData,
    setModifyPaymentModeData,
    setCurrentPaymentMode,
    setRoleId,
    setBankDropdown,
    setPaymentModeForm,
    roleId,
    setBankMasterId,
    balanceMode,
    setPaymentModeIdLimitList,
    bankDropdown,
    paymentModeIdLimitList,
    paymentModeFormHandler,
    collectVoucherList,
    studentBasicDetails,
    currentPaymentMode,
    paymentModeForm,
    selectedChargesAmount,
    bankMasterId,
    setBalanceMode,
    setBalanceAmount,
    loader,
    setloader,
    setCollectPayment,
    balanceAmount,
    collectPayment,
    availablePosList,
    state,
    setState,
  };
  const acknowledgementId = queryParams.get("acknowledgementId");
  const businessArea = queryParams.get("businessArea");
  const applicationId = queryParams.get("applicationId");
  const receiptId = queryParams.get("receiptId");
  const opportunityOwnerId = queryParams.get("opportunityOwnerId");

  const receiptData = {
    acknowledgementId,
    businessArea,
    applicationId,
    receiptId,
  };
  useEffect(() => {
    const getDetail = async () => {
      setReceiptLoader(true);
      let amountPaid = 0;
      const buId = await getBuIdByDisplayValue(businessArea);
      const res = await Promise.all([
        getReceiptDetail({ ...params, ...receiptData, buId } || {}),
      ]);

      res[0].paymentModeBreakupDTOList.forEach((item) => {
        amountPaid = amountPaid + item?.paidAmount;
      });
      const logDetail = await getLogDetails(params, receiptData, amountPaid);

      const details = {
        applicationId: applicationId,
        psid: params?.psid,
        buId: buId,
        receiptId: res[0]?.receiptNumber,
        receiptDate: res[0]?.receiptDate,
        businessArea: businessArea,
        term: res[0].term,
        courseId: res[0].courseIds[0],
        totalPaidAmount: amountPaid,
        acknowledgementId: acknowledgementId,
        courseType : res[0]?.courseType
      };
      setStudentBasicDetails((prev) => ({ ...prev, ...details }));
      headerValidation(
        res[0]?.acknowledgementId,
        res[0]?.receiptNumber,
        setHeader
      );
      receiptActionValidation(res[0], setActionDisable, businessArea, opportunityOwnerId);
      setTotalPaidAmount(amountPaid);
      setReceiptDeatail(res[0]);
      setLogDetails(logDetail);
      setReceiptLoader(false);
    };
    getDetail();
  }, []);

  return receiptLoader ? (
    <ALoader />
  ) : (
    <>
      <div className="large-text mx-5 my-4 label-color">
        <IconButtonWrapper onClick={() => window.close()}>
          <BackIcon />
        </IconButtonWrapper>
        Receipt {`(${header})`}
      </div>
      <div className="mx-5 d-flex justify-space-between">
        <div style={{ width: "65%" }}>
          <ReceiptDetail
            receiptDetail={{
              ...receiptDetail,
              receiptDate: receiptDetail?.receiptDate
                ? `${moment(receiptDetail?.receiptDate).format("DD-MMM-YYYY")}`
                : "-",
            }}
            totalPaidAmount={totalPaidAmount}
            setTotalPaidAmount={setTotalPaidAmount}
            contextValue={contextValue}
          />
          <LogsDetailListing rowList={logDetails} />
        </div>

        <ReceiptAction
          contextValue={contextValue}
          setActionDisable={setActionDisable}
          totalPaidAmount={totalPaidAmount}
          actionDisable={actionDisable}
          applicationId={applicationId}
          opportunityOwnerId ={opportunityOwnerId}
          studentBasicDetails={studentBasicDetails}
          rowList={
            receiptDetail?.paymentModeBreakupDTOList
              ? receiptDetail?.paymentModeBreakupDTOList.map((item, index) => ({
                  ...item,
                  paymentModeCollectionDetailsId:item?.id,
                  id: index,
                }))
              : []
          }
        />
      </div>
    </>
  );
};

export default ViewReceipt;
